// @ts-nocheck
import {Label} from '/ui/lib/props';
export {Label};

/**
 * @typedef {{
 *   columns: !Array<!Column>,
 *   dataRows: !Array<!Row>,
 *   label: !Label,
 *   emptyContent?: React.ReactNode,
 *   rowCallToAction?: !RowCallToAction,
 *   pagination?: React.ReactElement,
 *   paginationBelow?: boolean,
 *   filterBar?: React.ReactNode,
 *   filterPanel?: React.ReactNode,
 *   primaryActionLabel?: string,
 *   primaryActionOnClick?: !Function,
 *   moreActions?: React.ReactElement,
 *   rowSelectionOptions?: !RowSelectionOptions,
 *   isLoading?: boolean,
 *   getCellLoadingContents?: !getCellLoadingContents,
 *   noDataNumLoadingRows?: number,
 *   columnPickerConfig?: !ColumnPickerConfig,
 * }}
 */
export let TableProps;

/**
 * @typedef {(
 *   string |
 *   React.ReactNode
 * )}
 */
export let Datum;

/**
 * @typedef {!Object<string, !Datum>}
 * @property {string} id
 */
export let Row;

/**
 * @typedef {{
 *   id: string,
 *   label: (string|React.ReactNode),
 *   className?: string,
 *   width?: string,
 *   hidden?: boolean,
 * }}
 */
export let NonSortableColumn;

/**
 * @typedef {{
 *   id: string,
 *   label: (string|React.ReactNode),
 *   rowHeader?: boolean,
 *   className?: string,
 *   width?: string,
 *   isCallToAction: boolean,
 * }}
 */
export let CallToActionColumn;

/**
 * @typedef {{
 *   id: string,
 *   label: (string|React.ReactNode),
 *   rowHeader?: boolean,
 *   className?: string,
 *   width?: string,
 *   isSelect: boolean,
 * }}
 */
export let SelectColumn;

/**
 * @typedef {{
 *   id: string,
 *   label: (string|React.ReactNode),
 *   rowHeader?: boolean,
 *   className?: string,
 *   width?: string,
 *   onSort: function(string, !SortDirection):?,
 *   sortDirection: !SortDirection,
 *   hidden?: boolean,
 * }}
 */
export let SortableColumn;

/**
 * @typedef {(!NonSortableColumn | !SortableColumn | !CallToActionColumn | !SelectColumn)}
 */
export let Column;

/**
 * @typedef {function(Row): (React.ReactNode | null)}
 */
export let RowCallToAction;

/**
 * @enum {number}
 */
export const SortDirection = {
  ASCENDING: -1,
  DESCENDING: 1,
  NONE: 0,
};

/**
 * @enum {number}
 */
export const CheckboxState = {
  UNSELECTED: 0,
  INDETERMINATE: 1,
  SELECTED: 2,
};

/**
 * @typedef {{
 *   numSelected: number,
 *   selectAllState: !CheckboxState,
 * }}
 */
export let SelectionState;

/**
 * @typedef {{
 *   isSelected: (function(string): boolean),
 *   onSelectRow: (function(string, boolean): void),
 *   isDisabled?: (function(string): boolean),
 *   onSelectNone?: (function(): void),
 *   onSelectHeader?: (function(!CheckboxState): void),
 *   selectActions?: !Array<!{ name: string, callback: (function()) }>,
 *   numSelected?: (number | null),
 *   selectAllState?: !CheckboxState,
 *   selectedIds?: !Set<string>,
 *   isSingleSelect: boolean,
 * }}
 */
export let RowSelectionOptions;

/**
 * @typedef {function(string, !Row): React.ReactNode}
 */
export let getCellLoadingContents;

/**
 * @typedef {function(!Array<string>): void}
 */
export let onColumnPickerSelect;

/**
 * @typedef {function(): void}
 */
export let onColumnPickerReset;

/**
 * @typedef {Set}
 */
export let excludedColumns;

/**
 * @typedef {{
 *   onColumnPickerSelect: onColumnPickerSelect,
 *   onColumnPickerReset: onColumnPickerReset,
 *   excludedColumns?: excludedColumns,
 * }}
 */
export let ColumnPickerConfig;


/** @enum {string} */
export const ColActionTypes = {
  SET_COLUMNS: 'setColumns',
  SET_SORT_DIR: 'setSortDir',
  COL_PICKER_SELECT: 'colPickerSelect',
  COL_PICKER_RESET: 'colPickerReset',
};

/**
 * The Type should only be ColActionTypes.SET_COLUMNS, but it doesn't matter due to
 * how Closure's object union works anyways.
 * https://github.com/google/closure-compiler/wiki/Types-in-the-Closure-Type-System#union-types
 * @typedef {{
 *   type: !ColActionTypes,
 *   columns: !Array<!Column>,
 * }}
 */
export let ColActionSetColumns;

/**
 * @typedef {{
 *   type: !ColActionTypes,
 *   colId: string,
 *   newSortDirection: !SortDirection,
 * }}
 */
export let ColActionSetSortDir;

/**
 * selectedValues is an array of column IDs
 * @typedef {{
 *   type: !ColActionTypes,
 *   selectedValues: !Array<string>,
 * }}
 */
export let ColActionColPickerSelect;

/**
 * defaultColIds is an optional array of column IDs which should be visible on reset.
 * If not provided, all columns will be set visible.
 * @typedef {{
 *   type: !ColActionTypes,
 *   defaultColIds?: !Array<string>,
 * }}
 */
export let ColActionColPickerReset;

/**
 * @typedef {(
 *   ColActionSetColumns |
 *   ColActionSetSortDir |
 *   ColActionColPickerSelect |
 *   ColActionColPickerReset
 * )}
 */
export let ColAction;
